import { Injectable } from '@angular/core';
import {ConfigurationDataService} from '../configuration-data.service';
import {SharedDataService} from '../shared-data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {Bin} from './bin';

@Injectable()
export class BinService {

  headers = new HttpHeaders({
      'Content-Type': 'application/json'
  });

  constructor(public http: HttpClient, private config : ConfigurationDataService, private shared: SharedDataService) {
  }

  /**
   * List all bins which belong to loggedin user.
   */
  public list() {
    console.log(JSON.stringify(this.shared.getTokenAuthData()));
    return this.http.post(this.config.binURL+"list", JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public save(bin : Bin) {
    console.log('Push bin to insert method of service.');
    bin.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(bin));
    return this.http.post(this.config.binURL+"new", JSON.stringify(bin), {headers: this.headers});
  }

  public update(bin : Bin) {
    console.log('Push bin to update method of service.');
    bin.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(bin));
    return this.http.put(this.config.binURL+"id/"+bin.id, JSON.stringify(bin), {headers: this.headers});
  }

  public qryBin(id : number) {
    return this.http.post(this.config.binURL+"id/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public delete(id : number) {
    console.log('Delete bin '+ id);
    return this.http.post(this.config.binURL+"del/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/location/bin.service.ts